import { render, staticRenderFns } from "./InfoPanel.vue?vue&type=template&id=5354d7f2&scoped=true&"
import script from "./InfoPanel.vue?vue&type=script&lang=js&"
export * from "./InfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./InfoPanel.vue?vue&type=style&index=0&id=5354d7f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5354d7f2",
  null
  
)

export default component.exports